<lms-modal #modal className="padding-none" size="large" centered="true">
  <div class="translations-modal">
    <div class="translations-modal__header">{{ 'kepler.info.kpiTranslationsTitle' | translate }}</div>
    <div class="gl-popup__close" (click)="modal.close()">
      <span class="glicon-close"></span>
    </div>
    <div class="translations-modal__content">
      <div class="translations-modal__languages">
        <div class="translations-modal__title">{{ 'kepler.info.kpiTranslationsOrigen' | translate }}</div>
        <lms-dynamic-form
          *ngIf="kpisQuestions"
          [questions]="kpisQuestions"
          [options]="{ hideSubmit: true, disableCard: true }"
        >
        </lms-dynamic-form>
      </div>
      <div class="translations-modal__languages b-grey">
        <div class="translations-modal__title">{{ 'kepler.info.kpiTranslationsDestino' | translate }}</div>
        <lms-dynamic-form
          #translationForm
          *ngIf="kpisTranslatedQuestions"
          [questions]="kpisTranslatedQuestions"
          [options]="{ hideSubmit: true, disableCard: true }"
        >
        </lms-dynamic-form>
      </div>
    </div>
    <div class="translations-modal__footer">
      <gl-button class="margin-right" color-secondary [text]="'actions.cancel' | translate" (onClick)="modal.close()">
      </gl-button>
      <gl-button
        color-primary
        [text]="'actions.save' | translate"
        (onClick)="confirm()"
        [disabled]="!translationForm?.form?.valid"
      ></gl-button>
    </div>
  </div>
</lms-modal>
